/**
 * 文件定位：
 * 1. 当前文件位于 web-client/src/composables/revolve；
 * 2. 负责把旋转切除宿主命令收口到通用旋转会话；
 * 3. 几何、预览、提交均由 cad-core Viewer 执行。
 */

import { computed } from 'vue';
import { useRevolveFeature } from './useRevolveFeature';

/**
 * 旋转切除 Hook 选项。
 */
export type UseRevolveCutFeatureOptions = Parameters<typeof useRevolveFeature>[0];

/**
 * 创建旋转切除宿主会话。
 *
 * @param options Hook 配置。
 * @returns 旋转切除状态与动作。
 */
export function useRevolveCutFeature(options: UseRevolveCutFeatureOptions) {
  const controller = useRevolveFeature({
    ...options,
    featureKind: 'cut-revolve',
  });

  return {
    revolveCutUiState: computed(() => controller.revolveUiState.value),
    handleRevolveCutCommand: controller.handleRevolveCommand,
    handleRevolveCutSelectionChange: controller.handleRevolveSelectionChange,
    startEditingCutRevolveFeature: controller.startEditingRevolveFeature,
    submitRevolveCut: controller.submitRevolve,
    cancelRevolveCut: controller.cancelRevolve,
    activateRevolveCutPicker: controller.activateRevolvePicker,
    clearRevolveCutSelectedAxis: controller.clearRevolveSelectedAxis,
    clearRevolveCutSelectedContours: controller.clearRevolveSelectedContours,
    removeRevolveCutSelectedContour: controller.removeRevolveSelectedContour,
    highlightRevolveCutSelectedAxis: controller.highlightRevolveSelectedAxis,
    highlightRevolveCutSelectedContour: controller.highlightRevolveSelectedContour,
    setRevolveCutDirection1Angle: controller.setRevolveDirection1Angle,
    setRevolveCutDirection2Enabled: controller.setRevolveDirection2Enabled,
    setRevolveCutDirection2Angle: controller.setRevolveDirection2Angle,
    setRevolveCutDirectionReversed: controller.setRevolveDirectionReversed,
    setRevolveCutFlipSideToCut: controller.setRevolveFlipSideToCut,
    toggleRevolveCutFragment: controller.toggleRevolveCutFragment,
    setRevolveCutKeepBodiesSelectionMode: controller.setRevolveCutKeepBodiesSelectionMode,
    toggleRevolveCutKeepBodiesDraftFragment: controller.toggleRevolveCutKeepBodiesDraftFragment,
    confirmRevolveCutKeepBodiesDialog: controller.confirmRevolveCutKeepBodiesDialog,
    cancelRevolveCutKeepBodiesDialog: controller.cancelRevolveCutKeepBodiesDialog,
  };
}
